import type { ReactNode } from 'react';

import type { EntityOption } from '../../../chrome/entity/EntitySwitcher';
import type { Platform, TrackedAccountRow } from './api/schemas';
import { am } from './messages';

/** A tracked account as `EntityRow` draws it: its name, and its handle beside it only when a
 *  label displaces the handle from the name. */
export function accountOption(row: TrackedAccountRow): EntityOption {
  const handle = row.handle === null ? null : `@${row.handle}`;
  return {
    id: row.id,
    name: row.label ?? handle ?? am('unknownHandle'),
    detail: row.label === null ? null : handle,
    imageUrl: row.avatar_url,
    mark: <PlatformIcon platform={row.platform} className="size-3" />,
  };
}

export function platformLabel(platform: Platform): string {
  return platform === 'tiktok' ? am('platform.tiktok') : am('platform.instagram');
}

export function PlatformIcon({
  platform,
  className = 'size-4',
}: {
  platform: Platform;
  className?: string;
}): ReactNode {
  if (platform === 'tiktok') {
    return (
      <svg aria-hidden className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.24 1.07-.14 1.61.24 1.25 1.25 2.29 2.5 2.52 1.06.2 2.21-.08 2.97-.83.67-.62.97-1.54.98-2.43.02-4.52.01-9.04.01-13.56z" />
      </svg>
    );
  }
  return (
    <svg
      aria-hidden
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
}
